import React, { useState, useRef, useEffect } from 'react';
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import ApiService from '../services/api';
import './UserMenu.css';

const UserMenu = ({ user, onSignOut }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSuperUser, setIsSuperUser] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      onSignOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleManageInterviewers = () => {
    setIsOpen(false);
    navigate('/interviewers');
  };

  // Check if user is SuperUser
  useEffect(() => {
    const checkSuperUser = async () => {
      try {
        const superUserStatus = await ApiService.isSuperUser();
        setIsSuperUser(superUserStatus);
      } catch (error) {
        console.error('Error checking super user status:', error);
        setIsSuperUser(false);
      }
    };

    if (user) {
      checkSuperUser();
    }
  }, [user]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const userEmail = user?.signInDetails?.loginId || user?.username || 'Admin';

  return (
    <div className="user-menu" ref={menuRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)} 
        className="user-menu-trigger"
        aria-label="User menu"
      >
        <svg className="user-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
        </svg>
      </button>

      {isOpen && (
        <div className="user-menu-dropdown">
          <div className="user-info">
            <div className="user-email">{userEmail}</div>
          </div>
          <hr className="menu-divider" />
          {isSuperUser && (
            <button onClick={handleManageInterviewers} className="menu-option">
              Manage Interviewers
            </button>
          )}
          <button onClick={handleSignOut} className="sign-out-option">
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
